<template>
    <div id="eventList" v-if="renderComponent">

<!--        <div class="mobile-event-header-container" v-if="checkMobileStatus">-->
<!--            <h4>{{lang("Event")}}</h4>-->
<!--        </div>-->

        <div class="content-body-container col-md-12">
            <eventCom :paramTourData="passTourData"/>
        </div>
    </div>
</template>

<script>
    "use strict";
    import DataSource from "../data/datasource";

    // import eventCom from "../pages/Event";
    // import eventCom from "../pages/TestingPage1";
    import eventCom from "../pages/StaffEventCalendar";
    import {lang} from '../locale/index';
    import $ from 'jquery';
    import Cookies from "js-cookie";

    export default {
        name: "StaffEvent",
        components: {
            eventCom,
        },
        props: ["passTourData"],
        data() {
            return {
                renderComponent: true,
                isChange: false,
                checkMobileStatus: false,
                schoolID: "",
                isParent: "",
                parentSchIds: [],
            };
        },
        methods: {
            lang,
            isMobile() {
                let screenWidth = window.innerWidth;
                if (screenWidth <= 770) {
                    this.checkMobileStatus = true;
                    // return true;
                } else {
                    this.checkMobileStatus = false;
                    // return false;
                }
            },
        },
        created() {
            window.addEventListener('resize', this.isMobile);
        },
        destroyed  () {
            $(window).unbind('scroll');
            window.removeEventListener('resize', this.isMobile);
        },
        mounted() {
            const self = this;
            self.isMobile();

            $(document).ready(function(){
                $(".content-body-container").css("min-height", window.outerHeight);
                $(".sideBarSection__item").appendTo(".sidebar-action-container .action-body");
            });

            this.schoolID = Cookies.get('schoolSession');
            this.isParent = Cookies.get('userTypeSession');

            if (this.isParent === "Parent") {
                this.schoolIDs = JSON.parse(this.schoolID);
                this.schoolIDs = this.schoolIDs.Table;

                this.parentSchIds = [];
                this.schoolIDs.forEach((object, index) => {
                    this.parentSchIds.push(object.SCH_Ids);
                });
            }
        },
    }
</script>

<style scoped>
    .content-body-container {
        display: inline-block;
        padding: 20px;
        /*background: white;*/
        background: #edf0f4;
    }

    .mobile-event-header-container {
        text-align: center;
        border-radius: 4px 4px 0px 0px;
        padding: 10px 0px;
        margin: 0px;
        background: #3c3956;
        min-height: unset!important;
        color: white;
    }
</style>